import { defineStore } from 'pinia';
import api from '@/api/api';
import type {ZProfile} from "@schemas/profile.schemas";


export const useProfileStore = defineStore('profile', {
    state: () => ({
        profiles: [] as ZProfile[],
        currentProfile: null as ZProfile | null,
        profile: null as ZProfile | null
    }),
    actions: {
        clearMyData(): void {
            this.currentProfile = null;
        },
        async fetchCurrentProfile(): Promise<ZProfile> {
            if (!this.currentProfile) {
                this.currentProfile = await api.getDocument<ZProfile>('profiles', 'current');
            }
            return this.currentProfile;
        },
        async fetchProfile(profileId: string): Promise<ZProfile> {
            this.profile = this.profiles.find(app => app._id === profileId) ||
                await api.getDocument<ZProfile>('profiles', profileId);
            return this.profile;
        },
        async fetchByProfilesByType(profileId: string, profileType: string = "profiles"): Promise<ZProfile> {
            this.profile = this.profiles.find(app => app._id === profileId) ||
                await api.getDocument<ZProfile>(profileType, profileId);
            return this.profile;
        },
        async fetchProfiles(): Promise<ZProfile[]> {
            this.profiles = await api.getDocuments<ZProfile>('profiles');
            return this.profiles;
        },
        async addProfile(profile: ZProfile): Promise<ZProfile> {
            const newProfile = await api.postDocument<ZProfile>('profiles', profile);
            this.profiles.push(newProfile);
            return newProfile;
        },
        async updateProfile(profile: ZProfile): Promise<ZProfile> {
            const updatedProfile = await api.putDocument<ZProfile>('profiles/current', profile);
            this.profiles = this.profiles.map(profile => profile._id === updatedProfile._id ? updatedProfile : profile);
            this.currentProfile = this.currentProfile?._id === updatedProfile._id ? updatedProfile : this.currentProfile;
            // TODO if currentProfile is updated, update it as well

            return updatedProfile;
        },
        async removeProfile(profileId: string): Promise<void> {
            await api.deleteDocument<ZProfile>('profiles', profileId);
            this.profiles = this.profiles.filter(profile => profile._id !== profileId);
        },

        async contactProfile(profileId: string, formData: any): Promise<any> {
            // profiles/67c6f7cb93ce20a17a9247d4/contact
           return await api.postDocument<ZProfile>('profiles/' + profileId + '/contact', formData);
        }
    }
});
